module.exports = __webpack_public_path__ + "static/columbus_header-66abcd2b0e9815bf513566ebbd50c46e.jpg";